//----------------------------------------------------------
// Copied From Generated File TFS.WorkItemTracking.Constants.ts
//
// Generated data for the following assemblies:
// Microsoft.TeamFoundation.WorkItemTracking.Common
// Microsoft.TeamFoundation.WorkItemTracking.Server
// Microsoft.TeamFoundation.WorkItemTracking.Client
// Microsoft.TeamFoundation.Server.WebAccess.WorkItemTracking.Common
// Microsoft.TeamFoundation.Server.WebAccess.WorkItemTracking.PlugIns
// Microsoft.TeamFoundation.Favorites.WebApi
//----------------------------------------------------------

/// <amd-module name="Wit/Common/Generated/Constants" />
export enum CacheStatus {
    /**
     * Client cache matches server-side data
     */
    UpToDate = 0,
    /**
     * New data is returned for the client
     */
    NewData = 1,
    /**
     * Cache stamp doesn't match
     */
    StaleData = 2
}

export enum CoreField {
    Id = -3,
    Rev = 8,
    Title = 1,
    Description = 52,
    WorkItemType = 25,
    TeamProject = -42,
    State = 2,
    Reason = 22,
    CreatedBy = 33,
    AssignedTo = 24,
    ChangedBy = 9,
    ChangedDate = -4,
    CreatedDate = 32,
    RevisedDate = -5,
    AuthorizedDate = 3,
    AuthorizedAs = -1,
    History = 54,
    AreaPath = -7,
    AreaId = -2,
    IterationPath = -105,
    IterationId = -104,
    NodeName = -12,
    RelatedLinkCount = 75,
    HyperLinkCount = -32,
    AttachedFileCount = -31,
    ExternalLinkCount = -57,
    CommentCount = -33,
    LinkType = 100,
    Parent = -35,
    Tags = 80,
    Watermark = 7,
    BoardColumn = 90,
    BoardColumnDone = 91,
    BoardLane = 92,
    IsDeleted = -404
}

export module CoreFieldRefNames {
    export const AreaId = "System.AreaId";
    export const AreaPath = "System.AreaPath";
    export const AssignedTo = "System.AssignedTo";
    export const AttachedFileCount = "System.AttachedFileCount";
    export const AuthorizedAs = "System.AuthorizedAs";
    export const BoardColumn = "System.BoardColumn";
    export const BoardColumnDone = "System.BoardColumnDone";
    export const BoardLane = "System.BoardLane";
    export const ChangedBy = "System.ChangedBy";
    export const ChangedDate = "System.ChangedDate";
    export const CreatedBy = "System.CreatedBy";
    export const CreatedDate = "System.CreatedDate";
    export const Description = "System.Description";
    export const CommentCount = "System.CommentCount";
    export const ExternalLinkCount = "System.ExternalLinkCount";
    export const History = "System.History";
    export const HyperLinkCount = "System.HyperLinkCount";
    export const RemoteLinkCount = "System.RemoteLinkCount";
    export const Id = "System.Id";
    export const IterationId = "System.IterationId";
    export const IterationPath = "System.IterationPath";
    export const LinkType = "System.Links.LinkType";
    export const NodeName = "System.NodeName";
    export const Parent = "System.Parent";
    export const Reason = "System.Reason";
    export const RelatedLinkCount = "System.RelatedLinkCount";
    export const Rev = "System.Rev";
    export const RevisedDate = "System.RevisedDate";
    export const State = "System.State";
    export const AuthorizedDate = "System.AuthorizedDate";
    export const TeamProject = "System.TeamProject";
    export const Tags = "System.Tags";
    export const Title = "System.Title";
    export const WorkItemType = "System.WorkItemType";
    export const Watermark = "System.Watermark";
    export const IsDeleted = "System.IsDeleted";
}

/**
 * CoreLinkTypeReferenceNames
 */
export module CoreLinkTypeReferenceNames {
    export const Related = "System.LinkTypes.Related";
    export const Hierarchy = "System.LinkTypes.Hierarchy";
    export const Dependency = "System.LinkTypes.Dependency";
    export const Duplicate = "System.LinkTypes.Duplicate";
}

export module DalFields {
    export const IDId = -3;
    export const RevId = 8;
    export const TitleId = 1;
    export const DescriptionId = 52;
    export const WorkItemTypeId = 25;
    export const PortfolioProjectId = -42;
    export const WorkItemFormIDId = -14;
    export const WorkItemFormId = -15;
    export const StateId = 2;
    export const ReasonId = 22;
    export const CreatedById = 33;
    export const WatermarkId = 7;
    export const AssignedToId = 24;
    export const LastChangedById = 9;
    export const LastChangedDateId = -4;
    export const AuthorizedDateId = 3;
    export const CreatedDateId = 32;
    export const RevisedDateId = -5;
    export const PersonNameId = -1;
    export const AuthorizedAsId = -1;
    export const HistoryId = 54;
    export const AreaPathId = -7;
    export const AreaIDId = -2;
    export const IterationPathId = -105;
    export const IterationIDId = -104;
    export const NodeNameId = -12;
    export const RelatedLinkCountId = 75;
    export const RemoteLinkCountId = -34;
    export const LinkedFileCountId = -32;
    export const AttachedFileCountId = -31;
    export const CommentCountId = -33;
    export const ParentId = -35;
    export const BISURICountId = -57;
    export const Tags = 80;
    export const BoardColumnId = 90;
    export const BoardColumnDoneId = 91;
    export const BoardLaneId = 92;
    export const RelatedLinks = 37;
    export const PersonID = -6;
    export const LinkedFiles = 51;
    export const BISURI = 58;
    export const AttachedFiles = 50;
    export const HiddenAttachedFiles = 49;
    export const AreaLevel1 = -43;
    export const AreaLevel2 = -44;
    export const AreaLevel3 = -45;
    export const AreaLevel4 = -46;
    export const AreaLevel5 = -47;
    export const AreaLevel6 = -48;
    export const AreaLevel7 = -49;
    export const IterationLevel1 = -50;
    export const IterationLevel2 = -51;
    export const IterationLevel3 = -52;
    export const IterationLevel4 = -53;
    export const IterationLevel5 = -54;
    export const IterationLevel6 = -55;
    export const IterationLevel7 = -56;
    export const IsDeleted = -404;
    export const ZZZDummyField = -58;
}

/**
 * Constants for known favorite scopes in legacy storage model.
 */
export module FavoriteScopes {
    export const WORK_PLANS = "Work.Plans";
    export const WIT_QUERYITEMS = "WorkItemTracking.Queries";
    export const VC_PATHS = "VersionControl.Paths";
    export const BUILD_DEFINITIONS = "Build.Definitions";
    export const PROJECTS = "Classification.TeamProjects";
    export const TEAMS = "Team.Teams";
    export const REPOSITORIES = "VersionControl.Repositories";
    export const TEST_PLANS = "TestManagement.Plans";
}

/**
 * Constants for known favorite types.
 */
export module FavoriteTypes {
    export const WORK_PLAN = "Microsoft.TeamFoundation.Work.Plans";
    export const WORK_ITERATION = "Microsoft.TeamFoundation.Work.TeamIterations";
    export const WORK_TEAMBACKLOG = "Microsoft.TeamFoundation.Work.TeamBacklogs";
    export const WORK_TEAMBOARD = "Microsoft.TeamFoundation.Work.TeamBoardSets";
    export const WIT_QUERYITEM = "Microsoft.TeamFoundation.WorkItemTracking.QueryItem";
    export const VC_PATH = "Microsoft.TeamFoundation.VersionControl.Path";
    export const BUILD_DEFINITION = "Microsoft.TeamFoundation.Build.Definition";
    export const BUILD_DEFINITION_INITIALIZED = "Microsoft.TeamFoundation.Build.BuildDefinitionInitialized";
    export const PROJECT = "Microsoft.TeamFoundation.Classification.TeamProject";
    export const TEAM = "Microsoft.TeamFoundation.Teams.Team";
    export const TFVC_REPOSITORY = "Microsoft.TeamFoundation.Tfvc.Repository";
    export const GIT_REPOSITORY = "Microsoft.TeamFoundation.Git.Repository";
    export const TEST_PLAN = "Microsoft.TeamFoundation.TestManagement.Plan";
    export const DASHBOARD = "Microsoft.TeamFoundation.Dashboards.Dashboard";
}

export enum FieldType {
    Internal = 0,
    String = 1,
    Integer = 2,
    DateTime = 3,
    PlainText = 5,
    Html = 7,
    TreePath = 8,
    History = 9,
    Double = 10,
    Guid = 11,
    Boolean = 12,
    PicklistInteger = 14,
    PicklistString = 15
}

export module FollowsConstants {
    export const ArtifactType = "WorkItem";
    export const UnfollowResult = "UnfollowResult";
}

export enum FormLayoutType {
    Desktop = 0,
    Mobile = 1
}

export enum FieldFlags {
    None = 0x0000,
    Sortable = 0x0001,
    Computed = 0x0002,
    Editable = 0x0004,
    Ignored = 0x0008,
    Queryable = 0x0010,
    Reportable = 0x0020,
    PersonField = 0x0040,
    Cloneable = 0x0080,
    LongText = 0x0100,
    SupportsTextQuery = 0x0200
}

export enum FieldUsages {
    None = 0,
    WorkItem = 1,
    WorkItemLink = 2,
    Tree = 4,
    WorkItemTypeExtension = 8
}

export module OobFieldRefNames {
    export const BacklogPriority = "Microsoft.VSTS.Common.BacklogPriority";
    export const StackRank = "Microsoft.VSTS.Common.StackRank";
    export const ActivatedBy = "Microsoft.VSTS.Common.ActivatedBy";
    export const ActivatedDate = "Microsoft.VSTS.Common.ActivatedDate";
    export const ClosedBy = "Microsoft.VSTS.Common.ClosedBy";
    export const ClosedDate = "Microsoft.VSTS.Common.ClosedDate";
    export const ResolvedBy = "Microsoft.VSTS.Common.ResolvedBy";
    export const ResolvedDate = "Microsoft.VSTS.Common.ResolvedDate";
    export const StateChangeDate = "Microsoft.VSTS.Common.StateChangeDate";
    export const RemainingWork = "Microsoft.VSTS.Scheduling.RemainingWork";
    export const StartDate = "Microsoft.VSTS.Scheduling.StartDate";
    export const TargetDate = "Microsoft.VSTS.Scheduling.TargetDate";
}

export module QueriesConstants {
    export const LastVisitedQueryGroupKey = "LAST_VISITED_QUERY_GROUP";
    export const MyFavoritesGroupKey = "MY_FAVORITES_GROUP";
    export const LastVisitedQueryMruKey = "Queries/LastVisited";
    export const TeamFavoriteGroupsExpandStatesMruKey = "Queries/FavoriteGroupExpandStates";
}

/**
 * The format to generate for a query result
 */
export enum QueryResultFormat {
    Json = 0,
    Html = 1
}

export enum UnfollowResultStatus {
    unfollowFailed = 0,
    unfollowSuccess = 1
}

export module WellKnownControlNames {
    export const HtmlControl = "HtmlFieldControl";
    export const PlainTextControl = "PlainTextControl";
    export const FreshnessIndicatorControl = "FreshnessIndicatorControl";
    export const FieldControl = "FieldControl";
    export const DateControl = "DateTimeControl";
    export const ClassificationControl = "WorkItemClassificationControl";
    export const WorkItemLogControl = "WorkItemLogControl";
    export const WorkItemHistoryControl = "WorkItemHistoryControl";
    export const WorkItemStateGraphControl = "WorkItemStateGraphControl";
    export const LinksControl = "LinksControl";
    export const AttachmentsControl = "AttachmentsControl";
    export const WebpageControl = "WebpageControl";
    export const LabelControl = "LabelControl";
    export const TagFieldControl = "TagFieldControl";
    export const TestStepsControl = "TestStepsControl";
    export const AssociatedAutomationControl = "AssociatedAutomationControl";
    export const StageControl = "StageControl";
    export const StageBuildControl = "StageBuildControl";
    export const ReleaseBuildControl = "ReleaseBuildControl";
    export const AcceptanceCriteriaControl = "AcceptanceCriteriaControl";
    export const DevelopmentControl = "DevelopmentControl";
    export const WorkItemDiscussionControl = "WorkItemDiscussionControl";
    export const ParameterSetControl = "ParameterSetControl";
    export const DeploymentsControl = "DeploymentsControl";
}

export module WITCommonConstants {
    export const LinkTypes = "LinkTypes";
    export const WorkItemTypes = "WorkItemTypes";
    export const Nodes = "Nodes";
    export const Fields = "Fields";
    export const AllowedValues = "AllowedValues";
    export const ConstantSets = "ConstantSets";
    export const WorkItemTypeCategories = "WorkItemTypeCategories";
    export const TeamProjects = "TeamProjects";
    export const AdhocQueries = "AdhocQueries";
    export const WorkItemTrackingArea = "WIT";
    export const WitCacheProviderInit = "WorkItemTracking.CacheProvider.Initialize";
}

export module WorkItemFeatureStateConstants {
    export const DataProviderName = "ms.vss-work-web.work-item-feature-state-data-provider";
}

export module WorkItemFormContributionProperties {
    export const ShowOnDeletedWorkItem = "showOnDeletedWorkItem";
    export const Height = "height";
    export const Name = "name";
    export const Inputs = "inputs";
    export const InputId = "id";
    export const InputRequired = "isRequired";
    export const InputMode = "inputMode";
    export const InputValidation = "validation";
    export const InputDataType = "dataType";
    export const InputDescription = "description";
    export const InputType = "type";
    export const InputProperties = "properties";
    export const InputType_WorkItemField = "WorkItemField";
    export const FieldType = "Field";
    export const InputProperties_WorkItemFieldTypes = "workItemFieldTypes";
}

export module WorkItemFormExtensionsConstants {
    export const ContributionDefaultHeight_Group = 150;
    export const ContributionDefaultHeight_Control = 75;
    export const ContributionTarget_Form = "ms.vss-work-web.work-item-form";
    export const ContributionType_Page = "ms.vss-work-web.work-item-form-page";
    export const ContributionType_Group = "ms.vss-work-web.work-item-form-group";
    export const ContributionType_Control = "ms.vss-work-web.work-item-form-control";
    export const ContributionType_Notifications = "ms.vss-work-web.work-item-notifications";
}

export module WorkItemLinkConstants {
    export const RESOURCELINKTYPES = ["Hyperlink", "ArtifactLink"];
    export const WORKITEMLINKUSAGE = "workItemLink";
    export const RESOURCELINKUSAGE = "resourceLink";
    export const ATTACHEDLINKTYPE = "AttachedFile";
    export const HYPERLINKLINKTYPE = "Hyperlink";
    export const ARTIFACTLINKTYPE = "ArtifactLink";
    export const EXTERNALLINKTYPE = "ExternalLink";
    export const ATTRIBUTES_USAGE = "usage";
    export const ATTRIBUTES_EDITABLE = "editable";
    export const ATTRIBUTES_ENABLED = "enabled";
    export const ATTRIBUTES_ACYCLIC = "acyclic";
    export const ATTRIBUTES_DIRECTIONAL = "directional";
    export const ATTRIBUTES_SINGLETARGET = "singleTarget";
    export const ATTRIBUTES_TOPOLOGY = "topology";
    export const ATTRIBUTES_ID = "id";
    export const ATTRIBUTES_AUTHORIZEDDATE = "authorizedDate";
    export const ATTRIBUTES_RESOURCECREATEDDATE = "resourceCreatedDate";
    export const ATTRIBUTES_RESOURCEMODIFIEDDATE = "resourceModifiedDate";
    export const ATTRIBUTES_REVISEDDATE = "revisedDate";
    export const ATTRIBUTES_RESOURCESIZE = "resourceSize";
    export const ATTRIBUTES_COMMENT = "comment";
    export const ATTRIBUTES_NAME = "name";
    export const ATTRIBUTES_ISLOCKED = "isLocked";
}

export module WorkItemSettingsConstants {
    export const DataProviderName = "ms.vss-work-web.work-item-settings-data-provider";
    export const Path = "WorkItemTracking/Settings";
}

export module WorkItemTrackingMetadataCacheConstants {
    /**
     * Naming format for WIT cache cookies
     */
    export const CookieFormat = "WIT";
    /**
     * Id for data providers AB testing experiment
     */
    export const DataProviderExperimentId = "ms.vss-work-web.work-item-form-data-providers-experiment";
}

export module WorkItemTypeIcons {
    export const WorkItemTypeIconNames = [
        "icon_clipboard",
        "icon_crown",
        "icon_trophy",
        "icon_list",
        "icon_book",
        "icon_sticky_note",
        "icon_insect",
        "icon_traffic_cone",
        "icon_chat_bubble",
        "icon_flame",
        "icon_megaphone",
        "icon_code_review",
        "icon_code_response",
        "icon_review",
        "icon_response",
        "icon_test_plan",
        "icon_test_suite",
        "icon_test_case",
        "icon_test_step",
        "icon_test_parameter",
        "icon_star",
        "icon_ribbon",
        "icon_chart",
        "icon_headphone",
        "icon_key",
        "icon_airplane",
        "icon_car",
        "icon_diamond",
        "icon_asterisk",
        "icon_database_storage",
        "icon_government",
        "icon_gavel",
        "icon_parachute",
        "icon_paint_brush",
        "icon_palette",
        "icon_gear",
        "icon_check_box",
        "icon_gift",
        "icon_test_beaker",
        "icon_broken_lightbulb",
        "icon_clipboard_issue",
        "icon_github",
        "icon_pull_request",
        "icon_github_issue"
    ];
    export const DefaultWorkItemTypeIconName = "icon_clipboard";
}

export enum WorkItemTypes {
    Task = "Task",
    Bug = "Bug"
}

/**
 * Information that used for generating aria-label for the Card
 */
export interface CardAriaLabelInfo {
    /**
     * Focus was changed between Doing and Done columns
     */
    doneChanged: boolean;
    /**
     * Column was changed
     */
    columnChanged: boolean;
    /**
     * Row was changed
     */
    rowChanged: boolean;
}

export module WorkItemStateCategories {
    export const Completed = "Completed";
    export const InProgress = "InProgress";
    export const Proposed = "Proposed";
    export const Removed = "Removed";
    export const Resolved = "Resolved";
}
